/* jshint esversion: 6 */
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import localcache from '@/common/localcache'
import sessioncache from '@/common/sessioncache'
import FedLogOut from '@/store/modules/user'
import { changeRef, getSubSys } from '@/common/common'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 60000                  // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers['Request-From'] = 'WWW'
  if (store.getters.token) {
    config.headers['YAF-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  // console.dir(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 20000) {
      let msg = res.message
      // if (res.code === 50031) {
      //   if (res.message.length > 0) {
      //     msg = '无效提交：' + JSON.parse(res.message)[0].message
      //   }
      // }

      // 10000 系统重复提交太快，什么也不显示。
      if (res.code !== 10000) {
        if (msg === null || msg === undefined) {
          msg = "未知异常发生，请联系管理员"
        }
        Message({
          message: msg,
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        return sessioncache.get(res.cacheKey)
      }
      if (res.code == 50010) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录?', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(111)
          store.dispatch('FedLogOut').then(() => {
            console.log(112)
            // this.$router.push({ path: '/login' })
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }

      return Promise.reject('error')
    } else {
      // 允许服务端随时返回notice消息
      if (res.noticeCount !== null && res.noticeCount !== undefined) {
        localcache.set(localcache.SET_NOTICE_COUNT, res.noticeCount)
      }
      if (res.cacheKey) {
        sessioncache.set(res.cacheKey, res)
      }
      // if (res.message) {
      //   Message({
      //     message: res.message,
      //     type: 'success',
      //     duration: 5 * 1000
      //   })
      // } else if (res.data === undefined) {
      //   Message({
      //     message: '本次操作成功',
      //     type: 'success',
      //     duration: 5 * 1000
      //   })
      // }
      // if (res.message) {
      //   Message({
      //     message: res.message,
      //     type: 'success',
      //     duration: 5 * 1000
      //   })
      // }
      return changeRef(res)
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js